<script>
import {
  RexAutocomplete,
  RexDate,
  RexInput,
  RexSelect,
  RexTourists
} from '@/components/views/rexFieldsV2'

export default {
  name: 'FitRequest',
  components: {
    RexAutocomplete,
    RexSelect,
    RexInput,
    RexDate,
    RexTourists
  },
  computed: {
    form() {
      return this.$store.getters['fit/form']
    },
    isLoading() {
      return this.$store.getters['fit/isLoading']
    },
    filials() {
      return this.$store.getters['fit/filials']
    }
  },
  created() {
    this.$store.dispatch('fit/getFilials')
  },
  beforeDestroy() {
    this.$store.commit('fit/setInitialState')
  },
  methods: {
    send() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('fit/setIsLoading', true)

          const params = this.$store.getters['fit/getFormForCreate']

          this.$store.dispatch('fit/createRequest', params)
        }
      })
    }
  }
}
</script>
<template>
  <div class="search-form__content">
    <div class="search-form__form">
      <div class="fit-form__row fit-form__row--1">
        <rex-autocomplete
          placeholder="Страна"
          name="country"
          store-module="fit"
          target="form.country"
          endpoint="fitCountries"
          :is-disabled="isLoading"
          :validate="{
            required: true,
            autocomplete: form.country
          }"
        />
        <rex-autocomplete
          placeholder="Город"
          name="city"
          store-module="fit"
          target="form.city"
          endpoint="fitCountryCities"
          :is-disabled="isLoading || !form.country.slug"
          :params="{
            countryId: form.country.slug
          }"
          :validate="{
            required: true,
            autocomplete: form.city
          }"
        />
        <rex-date
          placeholder="Дата начала"
          name="checkInDate"
          store-module="fit"
          target="form.startDate"
          :is-disabled="isLoading"
          :allow-null-date="true"
          :validate="{
            required: true
          }"
        />
        <rex-tourists
          name="rooms"
          store-module="fit"
          target="form.rooms"
        />
      </div>
      <div class="fit-form__row fit-form__row--2">
        <rex-input
          label="Расскажите о своих пожеланиях к туру"
          type="textarea"
          name="wishes"
          store-module="fit"
          target="form.comment"
          :is-disabled="isLoading"
          :is-autosize="true"
          :min-height="136"
          :validate="{
            required: true,
            min: 10,
            max: 500
          }"
        />
        <div class="fit-form__column fit-form__column--padded">
          <div class="fit-form__column-item">
            <rex-select
              label="Филиал"
              name="filial"
              store-module="fit"
              target="form.filialId"
              empty-label="Не выбран"
              :options="filials"
              :is-disabled="isLoading"
              :hide-if-empty="false"
              :validate="{
                required: true
              }"
            />
          </div>
          <div class="fit-form__column-item">
            <rex-input
              label="Желаемый бюджет"
              type="text"
              name="budget"
              store-module="fit"
              placeholder="200 000 руб."
              target="form.budget"
              :is-disabled="isLoading"
              :validate="{
                required: true
              }"
            />
          </div>
        </div>
      </div>
      <div class="fit-form__row fit-form__row--3">
        <rex-input
          label="Имя"
          name="name"
          store-module="fit"
          target="form.name"
          :is-disabled="isLoading"
          :validate="{
            required: true
          }"
        />
        <rex-input
          label="Фамилия"
          name="surname"
          store-module="fit"
          target="form.surname"
          :is-disabled="isLoading"
          :validate="{
            required: true
          }"
        />
        <rex-input
          label="Телефон"
          name="phone"
          store-module="fit"
          target="form.phone"
          placeholder="+7 ХХХХ ХХ ХХ ХХ"
          :is-disabled="isLoading"
          :validate="{
            required: true,
            phone: form.phone
          }"
        />
        <rex-input
          label="email"
          name="email"
          store-module="fit"
          target="form.email"
          placeholder="ivanov@email.ru"
          :is-disabled="isLoading"
          :validate="{
            required: true,
            email: true
          }"
        />
        <div class="fit-form__column fit-form__column--action">
          <b-button
            class="rex-button2"
            type="is-primary"
            :disabled="isLoading"
            :loading="isLoading"
            expanded
            @click="send"
          >
            Отправить заявку
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>